import React from 'react'
import Calendar from 'components/Calendar'

const Layout = ({colorScheme, colors, eventLimitClick, defaultView, language, options,
    eventDrop, dateClick, eventClick, events, getLabel, getColorId, getColor, ownerFilter, consumerFilter, calendarRef}) => {
    
    const data = ownerFilter || consumerFilter ? events.filter(item => {
        const owner = ownerFilter ? item.ownerId === ownerFilter : true
        const consumer = consumerFilter ?
            consumerFilter === options.free ? item.consumerId === '' :
            consumerFilter === options.reserved ? item.consumerId !== '' :
            item.consumerId === consumerFilter : true

        return owner && consumer
    }) : events        
	
    return (
        <Calendar
            data={data}
            colors={colors}
            language={language}
            dateClick={dateClick}
            eventClick={eventClick}
            eventDrop={eventDrop}
            colorScheme={colorScheme}
            eventLimitClick={eventLimitClick}
            ref={calendarRef}
            defaultView={defaultView}
            getLabel={getLabel}
            getColorId={getColorId}
            getColor={getColor}
            scheduler
        />
    )
}

export default React.memo(React.forwardRef((props, ref) => <Layout calendarRef={ref} {...props} />))
